var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":require("@/assets/img/observa-logo.png"),"alt":"Observa"}})])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }